import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';

export function FacilityFeeItem({
	fee, value
}) {
	return (
		<li className="facility-fee-item">
			<Text className="fee-name">
				{fee}:
			</Text>
			<Text className="fee-value">
				{value}
			</Text>
		</li>
	);
}

FacilityFeeItem.propTypes = {
	fee: PropTypes.node.isRequired,
	value: PropTypes.node.isRequired
};

export default FacilityFeeItem;
